// extracted by mini-css-extract-plugin
export default {"wrapFirstcols":"graficos_wrapFirstcols__RKl44"};